import { render, staticRenderFns } from "./Setup.vue?vue&type=template&id=571099c3&"
import script from "./Setup.vue?vue&type=script&lang=js&"
export * from "./Setup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports